import { USER_PATH } from '@/constants';

export const USER_DETAIL_PATH = 'detail/:userId/:motherId';

export const getUserDetailUrl = (userId: number, motherId: number) => {
    return `/${USER_PATH}/${USER_DETAIL_PATH}`.replace(':userId', String(userId)).replace(':motherId', String(motherId));
}